import Repository from "@/services/repository";

export default {
  getPageStatus(studyId, url) {
    return Repository.post(`/a/${studyId}/configuration/get_page_status.json`, {
      url: url,
    }).then((response) => response.data);
  },
  updateAlerts(studyId, alerts) {
    return Repository.post(`/a/${studyId}/configuration/update_alerts.json`, {
      alerts,
    }).then((response) => response.data);
  }
};
